import { ParameterType } from '@/study-search/enums';
import { FilterDefinition } from './FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { TuitionFeeFilterOptionValue } from '@studyportals/search-filters/server-side';

class TuitionFeeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.TUITION_FEE,
			[new FilterOptionInformation('0-2500', TuitionFeeFilterOptionValue.ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED, 'affordable', 'Affordable')],
			[TuitionFeeFilterOptionValue.ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED],
		);
	}
}

export default new TuitionFeeFilterDefinition();
